import React, { Fragment, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";

function InputComponent(props) {
  const [clear, setClear] = useState("");
  const {
    label = "",
    varient = "standard",
    icon,
    disabled,
    handleChange,
    fullWidth,
    placeHolder = "",
    required = false,
    error = false,
    helperText = "",
  } = props;
  return (
    <div>
      <TextField
        error={error}
        id="input-with-icon-textfield"
        label={label}
        placeholder={placeHolder}
        InputProps={
          props.type !== "number"
            ? {
                endAdornment: (
                  <InputAdornment position="start">{icon}</InputAdornment>
                ),
              }
            : { inputMode: "numeric", pattern: "[0-9]*" }
        }
        variant={varient}
        fullWidth={fullWidth}
        disabled={disabled}
        onChange={handleChange}
        type={props.type || ""}
        required={required}
        helperText={helperText}
      />
    </div>
  );
}

export default InputComponent;
